import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { RouterOutlet } from "@angular/router";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
  imports: [RouterOutlet],
  standalone: true,
})
export class AppComponent {
  constructor(private translate: TranslateService) {
    this.translate.addLangs(["en", "de"]);
    // this language will be used as a fallback when a translation isn't found in the current language
    this.translate.setDefaultLang("en");

    let preferredlanguage: string | null = null;
    if (localStorage) {
      preferredlanguage = localStorage.getItem(
        "blumnovotest_preferredlanguage"
      );
    }

    if (preferredlanguage == null) {
      const browserLang = translate.getBrowserLang();
      preferredlanguage = browserLang?.match(/en|de/) ? browserLang : "en";
    }

    this.translate.use(preferredlanguage);

    console.debug("Using language " + preferredlanguage);
  }
}
